import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import App from './mobioastro/containers/app';
import register from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './redux/configureStore';
import { IntlProvider, addLocaleData } from "react-intl";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import LangWrapper from './LangWarppper';




ReactDOM.render(<Provider store={store} ><LangWrapper/></Provider >, document.getElementById('root'));

// register();



// WEBPACK FOOTER //
// ./src/index.js